import { render, staticRenderFns } from "./veSbzcJzwRoomcate.vue?vue&type=template&id=649870e6&scoped=true"
import script from "./veSbzcJzwRoomcate.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwRoomcate.vue?vue&type=script&lang=js"
import style0 from "./veSbzcJzwRoomcate.vue?vue&type=style&index=0&id=649870e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649870e6",
  null
  
)

export default component.exports